module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/node_modules/websocket/lib/version.js
// module id = ../../../../websocket/lib/version.js
// module chunks = vendor